<template>
  <div>
    <logs-header></logs-header>
    <calendar-provider
      v-if="renderComponent && isCalendarView"
    ></calendar-provider>
    <timeline-provider
      v-if="renderComponent && !isCalendarView"
    ></timeline-provider>
  </div>
  <budget-dialog v-if="isOpen && type === 'budgets'"></budget-dialog>
  <receipt-dialog-provider
    v-if="isOpen && type === 'receipt'"
  ></receipt-dialog-provider>
  <activities-dialog-provider
    v-if="isOpen && type === 'politicalAction'"
  ></activities-dialog-provider>
</template>

<script>
import { ref, watch, nextTick, onBeforeMount } from 'vue'

import LogsHeader from '@/components/layout/logs/LogsHeader'
import BudgetDialog from '@/components/layout/budgets/BudgetDialog.vue'
import ActivitiesDialogProvider from '@/components/provider/ActivitiesDialogProvider'
import ReceiptDialogProvider from '@/components/provider/ReceiptDialogProvider'
import TimelineProvider from '@/components/provider/TimelineProvider'
import CalendarProvider from '@/components/provider/CalendarProvider'
import { useYearSelector } from '@/services/useYearSelector'
import { useLogs } from '@/services/useLogs'
import { useDialog } from '@/services/useDialog'

export default {
  name: 'Logs',

  components: {
    LogsHeader,
    BudgetDialog,
    ActivitiesDialogProvider,
    ReceiptDialogProvider,
    TimelineProvider,
    CalendarProvider,
  },

  setup() {
    const renderComponent = ref(true)
    const { currentYear, resetYear } = useYearSelector()
    const { isOpen, type } = useDialog()

    watch(currentYear, (currentYear, newval) => {
      if (currentYear != newval) reRenderComponent()
    })

    const reRenderComponent = () => {
      renderComponent.value = false
      nextTick(() => {
        renderComponent.value = true
      })
    }

    onBeforeMount(async () => {
      await resetYear()
    })

    return { renderComponent, isOpen, type, ...useLogs() }
  },
}
</script>
